<template>
	<div>
		<header-top></header-top>
    <div class="price-library">
      <div class=" main-width">
        <div class="price-library-title">报价篮子</div>
        <el-menu :default-active="index" mode="horizontal" @select="handleSelectStatus" active-text-color="#ffa726">
          <el-menu-item index="1">全部商品</el-menu-item>
          <el-menu-item index="2">报价表</el-menu-item>
        </el-menu>
      </div>
    </div>
    <div style="height: 310px"></div>
		<router-view></router-view>
	</div>
</template>
<script>
	import headerTop from "../components/Header";

	export default{
    data() {
      return {
        index: '1'
      };
    },
		components: {
			headerTop
    },
    watch: {
      // 如果路由有变化，会再次执行该方法
      "$route": "routeChange"
    },
    created(){
      this.routeChange();
    },
    mouted(){

    },
    methods: {
      routeChange(){
		    var url = window.location.href;
				var strs = url.split("/");
        var str = strs[strs.length - 1];
        if(str == 'goods'){
          this.index = '1'
        }else if(str == 'list'){
          this.index = '2'
        }
      },
      handleSelectStatus(index) {
       this.index = index;
       if(index == 1){
         this.$router.push({ name: 'PriceLibraryGoods', params: { }})
       }else if(index == 2){
         this.$router.push({ name: 'PriceLibraryList', params: { }})
       }
      },
    }
	}
</script>
<style scoped>
  .price-library{
    position: fixed;
    width: 100%;
    top: 168px;
    background-color: #fff;
    z-index: 1000;
  }
  .price-library-title{
    color: #ffa726;
    font-size: 28px;
    font-weight: bold;
    background: #FFF7EE;
    padding: 15px;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// PriceLibrary.vue?52f1d36c